export function getAction(client, action) {
    return (params) => client[action.name]?.(params) ?? action(client, params);
}
//# sourceMappingURL=getAction.js.map